export default {
    CANCEL: 'Cancel',
    SAVE: 'Save',
};
